import { render, staticRenderFns } from "./single-picture.vue?vue&type=template&id=92b2a950&scoped=true&"
import script from "./single-picture.vue?vue&type=script&lang=ts&"
export * from "./single-picture.vue?vue&type=script&lang=ts&"
import style0 from "./single-picture.vue?vue&type=style&index=0&id=92b2a950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b2a950",
  null
  
)

component.options.__file = "single-picture.vue"
export default component.exports